export default __webpack_public_path__ + "static/media/OJ_logo.5432aa8d.svg";